/**
 * Converts English text (as if typed on English keyboard) to Persian (Farsi)
 * Useful for search inputs when user forgot to switch keyboard layout.
 */
const enToFaMap: Record<string, string> = {
  q: 'ض',
  w: 'ص',
  e: 'ث',
  r: 'ق',
  t: 'ف',
  y: 'غ',
  u: 'ع',
  i: 'ه',
  o: 'خ',
  p: 'ح',
  '[': 'ج',
  ']': 'چ',
  a: 'ش',
  s: 'س',
  d: 'ی',
  f: 'ب',
  g: 'ل',
  h: 'ا',
  j: 'ت',
  k: 'ن',
  l: 'م',
  ';': 'ک',
  "'": 'گ',
  z: 'ظ',
  x: 'ط',
  c: 'ز',
  v: 'ر',
  b: 'ذ',
  n: 'د',
  m: 'پ',
  ',': 'و',
  '.': '.',
  '/': '/',

  // Shifted / uppercase
  Q: 'ْ',
  W: 'ٌ',
  E: 'ٍ',
  R: 'ً',
  T: 'ُ',
  Y: 'ِ',
  U: 'َ',
  I: 'ّ',
  O: ']',
  P: '[',
  '{': '}',
  '}': '{',
  A: 'ؤ',
  S: 'ئ',
  D: 'ي',
  F: 'إ',
  G: 'أ',
  H: 'آ',
  J: 'ة',
  K: '«',
  L: '»',
  ':': ':',
  '"': '؛',
  Z: 'ء',
  X: '>',
  C: 'ژ',
  V: 'ؤ',
  B: '<',
  N: '»',
  M: '؟',
  '<': '>',
  '>': '<',
  '?': '؟',

  // Numbers and symbols (server stores numbers as English so we don't need them in the map)
  // '1': '۱',
  // '2': '۲',
  // '3': '۳',
  // '4': '۴',
  // '5': '۵',
  // '6': '۶',
  // '7': '۷',
  // '8': '۸',
  // '9': '۹',
  // '0': '۰',
  // '!': '!',
  // '@': '٬',
  // '#': '٫',
  // $: '﷼',
  // '%': '٪',
  // '^': '×',
  // '&': '،',
  // '*': '*',
  // '(': '(',
  // ')': ')',
  // '-': '-',
  // _: '_',
  // '=': '=',
  // '+': '+',
  // '\\': '\\',
  // '|': '|',
};

function translate(text: string) {
  if (!text) return '';

  return text
    .split('')
    .map((char) => {
      // Return mapped character or original if no mapping exists
      return enToFaMap[char] || char;
    })
    .join('');
}

export { translate };
